import React, { useState, useEffect } from 'react'
import FlexView from 'react-flexview'
import { Grid, Switch, Typography, Divider, TextField } from '@material-ui/core'
import { DairylandCustomerForm } from './DairylandCustomerForm'
import ReportsApi from '../../api/reports.api'
import { awaitWithLoading } from '../../services/utils'
import dayjs from 'dayjs'

export const DairylandCustomer = () => {
  const [isDairylandCustomer, setIsDairylandCustomer] = useState(undefined)
  const [externalPolicyValues, setExternalPolicyValues] = useState(undefined)
  const [isNewCustmer, setIsNewCustomer] = useState(true)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const res = await awaitWithLoading(ReportsApi.getExternalPolicy())
    if (res.ok) {
      setIsDairylandCustomer(true)
      setExternalPolicyValues({
        purchase_date: dayjs(res.data.purchase_date).format('YYYY-MM-DD'),
        effective_date: dayjs(res.data.effective_date).format('YYYY-MM-DD'),
        premium: res.data.premium_value,
        comment: res.data.comment,
      })
      setIsNewCustomer(false)
    } else {
      setIsDairylandCustomer(false)
      setExternalPolicyValues({
        purchase_date: null,
        effective_date: null,
        premium: null,
        comment: '',
      })
    }
  }

  const onSubmitForm = async data => {
    if (isNewCustmer) {
      awaitWithLoading(
        ReportsApi.createExternalPolicy(
          dayjs(data.purchase_date).format('YYYY-MM-DD'),
          dayjs(data.effective_date).format('YYYY-MM-DD'),
          data.premium,
          data.comment
        )
      )
      setIsNewCustomer(false)
    } else {
      awaitWithLoading(
        ReportsApi.updateExternalPolicy(
          dayjs(data.purchase_date).format('YYYY-MM-DD'),
          dayjs(data.effective_date).format('YYYY-MM-DD'),
          data.premium,
          data.comment
        )
      )
    }
  }

  const onToggleChange = async () => {
    if (isDairylandCustomer) {
      awaitWithLoading(ReportsApi.deleteExternalPolicy())
      setIsNewCustomer(true)
    }
    setIsDairylandCustomer(!isDairylandCustomer)
  }

  return (
    <Grid container className="margin-left-basic font-semibold text-sm  width-70">
      <div className="flex flex-col margin-top-basic width-full">
        <div className="text-title blue bold">Dairyland Customer</div>
        <Divider />
      </div>
      <Grid item xs={12} className="margin-bottom-24">
        <Grid item xs={12} className="margin-bottom-24">
          <FlexView className="space-between" vAlignContent={'center'}>
            <Typography className="gray">Is the customer bound through Dairyland?</Typography>
            {isDairylandCustomer !== undefined && <Switch onChange={onToggleChange} checked={isDairylandCustomer} color="primary" />}
          </FlexView>
        </Grid>
        {externalPolicyValues !== undefined && (
          <DairylandCustomerForm hidden={isDairylandCustomer === false} onSubmitForm={onSubmitForm} defaultValues={externalPolicyValues} />
        )}
      </Grid>
    </Grid>
  )
}
